'use client';

import React, { createContext, useContext, useState } from 'react';

// Tipo do track reference (mesmo tipo usado em EvoluVideoConference)
// Usamos any temporariamente pois o tipo exato depende do retorno de useTracks
type TrackRef = any;

interface PinningContextType {
  pinnedTrackRef: TrackRef | null;
  setPinnedTrackRef: (track: TrackRef | null) => void;
}

export const PinningContext = createContext<PinningContextType | undefined>(undefined);

export function PinningProvider({ children }: { children: React.ReactNode }) {
  const [pinnedTrackRef, setPinnedTrackRef] = useState<TrackRef | null>(null);

  return (
    <PinningContext.Provider value={{ pinnedTrackRef, setPinnedTrackRef }}>
      {children}
    </PinningContext.Provider>
  );
}

export const usePinning = () => {
  const context = useContext(PinningContext);
  if (!context) throw new Error('usePinning must be used within a PinningProvider');
  return context;
};

